import { motionValue, animate } from "motion/react";

// Single shared MotionValue — animated once, read by every ApplianceCard via useTransform.
// Because all cards subscribe to the same value they are always in phase.
export const appliancePulse = motionValue(0);

animate(appliancePulse, [0, 1], {
  duration: 2.5,
  repeat: Infinity,
  repeatType: "mirror",
  ease: "easeInOut",
});
